import React from "react";
import { useDispatch } from "react-redux";
import { clearNoPermission } from "../../../redux/actions/accessActions";
import "./css/AuthModal.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

const NoPermissionModal: React.FC = () => {
	const dispatch = useDispatch();
	const gifUrl = "https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExODJybDZvNThwZmQ3eG9yOXppZ2wwOGJjNDk1NDlvajRycThxM2N5byZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/dpJX6BkwptfbclunyK/giphy.gif";

	const handleClose = () => {
		dispatch(clearNoPermission());
	};

	const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
		if (e.target === e.currentTarget) {
			handleClose();
		}
	};

	return (
		<div className="modal-overlay" onClick={handleOverlayClick}>
			<div className="modal-box">
				<FontAwesomeIcon icon={faXmark} onClick={handleClose} className="close-btn" />
				<h3>Acceso denegado</h3>
				<p style={{ margin: 0 }}>No tienes permiso para ver esta sección.</p>
                <img src={gifUrl} alt="No permission" style={{ width: "100%", marginTop: "1rem", borderRadius: "8px" }} />
			</div>
		</div>
	);
};

export default NoPermissionModal;
